import DapDSTab from './tab.component'

export * from './tab.component'
export default DapDSTab

DapDSTab.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-tab': DapDSTab
  }
}
